<template>
    <v-container fluid>
        <v-row align="center" justify="end" class="ma-6">
            <v-col cols="7" sm="auto">
                <AddCustomers @added="reloadCustomers"/>
            </v-col>

            <v-col cols="12">
                <SearchCustomers class="mb-6" @search="filterCustomers" @cleared="reloadCustomers"/>

                <CustomersList 
                    class="elevation-4 rounded"
                    :dense="false" 
                    :loading="loading"
                    :customerKey="'name'" 
                    :customers="customers"
                    :emailEditable="false"
                    :paginated="false"
                    @updated="updateCustomer"
                    @report="updateCustomerReport"
                    @removed="removeCustomer" />

            </v-col>
            <v-col cols="12" class="my-6 py-6 text-center">
                <v-btn 
                    text 
                    v-if="token !== undefined"
                    @click="loadCustomers" 
                    :loading="loading">
                    <v-icon left>mdi-reload</v-icon>
                    {{ $t('views.Customers.LoadMoreButton') }}
                </v-btn>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import EventBus from '@/utils/EventBus';
import CustomersAPI from '@/utils/CustomersAPI';

import SearchCustomers from '@/components/customers/SearchCustomers';
import AddCustomers from '@/components/customers/AddCustomers';
import CustomersList from '@/components/customers/CustomersList';


/**
 * Customers component includes the features to create a new single customer, a
 * group of new customers at the same time and to list, edit and delete current
 * customers. It also allows to administrators to search customer by their name.
 * It uses the CustomersAPI class to get and search customers.
 */
export default {
    name: 'Customers',
    data: () => ({
        loading: false,
        customers: [],
        token: null,
        query: null,
        end: false
    }),
    async mounted() {
        await this.loadCustomers();
    },
    methods: {
        async loadCustomers() {
            this.loading = true;

            const [ customers, tokenOrError ] = (this.query) ?
                await CustomersAPI.findCustomers(this.query, this.token) :
                await CustomersAPI.listCustomers(this.token);

            if (customers) {
                if (this.token !== undefined) this.customers.push(...customers);
                this.token = tokenOrError;
            } else EventBus.$emit('popup', tokenOrError);
            this.loading = false;
        },
        async filterCustomers(query) {
            if (query && query.length >= 3) {
                this.customers = [];
                this.query = query;
                this.token = null;
                await this.loadCustomers();
            }
        },
        async reloadCustomers() {
            this.query = null;
            this.token = null;
            this.customers = [];
            await this.loadCustomers();
        },
        async updateCustomer(index, customer) {
            this.loading = true;
            const { email, name, clinics, report, app_version } = customer;
            const [ success, result ] = await CustomersAPI.updateCustomer(email, name, clinics, report, app_version);
            
            if (success) await this.reloadCustomers();
            this.loading = false;
            EventBus.$emit('popup', result);
        },
        async updateCustomerReport(index, customer) {
            this.loading = true;
            const { email, report } = customer;
            const [ success, result ] = await CustomersAPI.updateCustomerReport(email, report);

            if (success) await this.reloadCustomers();
            this.loading = false;
            EventBus.$emit('popup', result);
        },
        async removeCustomer(index, customer) {
            this.loading = true;

            const [ success, result ] = await CustomersAPI.deleteCustomer(customer.email);
            if (success) {
                this.customers.splice(index, 1);
                this.customers = [...this.customers];
            }

            this.loading = false;
            EventBus.$emit('popup', result);
        }
    },
    components: { SearchCustomers, AddCustomers, CustomersList }
}
</script>
